<h2 class="d-flex" mat-dialog-title data-testid="modalconfirm-title">{{ title }}</h2>
<mat-dialog-content class="d-flex mat-typography">
  <div [innerHTML]="message" data-testid="modalconfirm-text"></div>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-end">
  <button
    *ngIf="secondaryOption"
    mat-stroked-button
    class="border-0"
    color="primary"
    [mat-dialog-close]="false"
    data-testid="modalconfirm-button-nao"
  >
    {{ secondaryOption }}
  </button>
  <button
    mat-raised-button
    class="border-0"
    [color]="primaryOptionColor"
    [mat-dialog-close]="true"
    data-testid="modalconfirm-button-sim"
  >
    {{ primaryOption }}
  </button>
</mat-dialog-actions>
